import React from 'react'
import ReactDOM from 'react-dom'
import { FlagsProvider } from 'react-feature-flags'
import { applyMiddleware, compose, createStore } from 'redux'
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'
import { DndProvider } from 'react-dnd'
import Backend from 'react-dnd-html5-backend'
import App from 'components/App'
import reducers from 'reducers'
import * as Sentry from '@sentry/browser'
import isMapboxGLSupported from '@mapbox/mapbox-gl-supported'

if (window.SENTRY_DSN) {
    Sentry.init({ dsn: window.SENTRY_DSN, release: window.SENTRY_RELEASE })
}

const composeEnhancers = (window.SETTINGS.debug && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose
const store = createStore(reducers, composeEnhancers(applyMiddleware(thunk)))
const glSupported = isMapboxGLSupported()

const queryParameters = new URLSearchParams(window.location.search)
const access = queryParameters.get('access')

const flags = [
    { name: 'staging', isActive: access === 'staging' },
    { name: 'staging-hide', isActive: access !== 'staging' },
    { name: 'live', isActive: true }
]

ReactDOM.render(
    <FlagsProvider value={flags}>
        <Provider store={store}>
            <DndProvider backend={Backend}>
                {glSupported && <App />}
                {!glSupported && (
                    <div className="no-webgl">
                        Your browser does not support WebGL, which is required to use SiteCheck. You can find more
                        information about WebGL at <a href="https://get.webgl.org/">get.webgl.org</a>
                    </div>
                )}
            </DndProvider>
        </Provider>
    </FlagsProvider>,
    document.getElementById('app')
)
